import { render, staticRenderFns } from "./NewUserModal.vue?vue&type=template&id=631606fc&scoped=true&"
import script from "./NewUserModal.vue?vue&type=script&lang=js&"
export * from "./NewUserModal.vue?vue&type=script&lang=js&"
import style0 from "./NewUserModal.vue?vue&type=style&index=0&id=631606fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631606fc",
  null
  
)

export default component.exports